import Timestamp from "components/Timestamp";

import { CellComponentProps } from "./types";

type ContextListItemCreatedAtCellProps = CellComponentProps;

const ContextListItemCreatedAtCell = ({ context }: ContextListItemCreatedAtCellProps) => {
  if (!context.createdAt) {
    return null;
  }

  return <Timestamp timestamp={context.createdAt!} />;
};

export default ContextListItemCreatedAtCell;
